// Quản lý các biến môi trường theo từng loại môi trường

// Các loại môi trường
export enum Environment {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

// Lấy môi trường hiện tại
export const getCurrentEnvironment = (): Environment => {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;
  
  switch (env) {
    case 'production':
      return Environment.PRODUCTION;
    case 'staging':
      return Environment.STAGING;
    default:
      return Environment.DEVELOPMENT;
  }
};

// Kiểm tra môi trường hiện tại
export const isProduction = (): boolean => getCurrentEnvironment() === Environment.PRODUCTION;
export const isStaging = (): boolean => getCurrentEnvironment() === Environment.STAGING;
export const isDevelopment = (): boolean => getCurrentEnvironment() === Environment.DEVELOPMENT;

// Thông tin môi trường
const ENV_CONFIG = {
  [Environment.DEVELOPMENT]: {
    name: 'Development',
    apiDomain: process.env.REACT_APP_API_URL || 'http://localhost:8080',
    // Thêm các biến khác nếu cần
  },
  [Environment.STAGING]: {
    name: 'Staging',
    apiDomain: process.env.REACT_APP_API_URL || 'https://api-tracker.mmoall.com',
    // Thêm các biến khác nếu cần
  },
  [Environment.PRODUCTION]: {
    name: 'Production',
    apiDomain: process.env.REACT_APP_API_URL || 'https://api-tracker.mmoall.com',
    // Thêm các biến khác nếu cần
  },
};

// Lấy cấu hình theo môi trường hiện tại
export const getEnvironmentConfig = () => {
  return ENV_CONFIG[getCurrentEnvironment()];
};

export default {
  getCurrentEnvironment,
  isProduction,
  isStaging,
  isDevelopment,
  getEnvironmentConfig,
}; 